module.exports = __webpack_public_path__ + "static/media/staying-focused.9dd7772f.svg";